<template>
  <div class="k-row" :style="rowStyle" :class="rowClass">
    <slot></slot>
  </div>
</template>
<script>
export default {
  name: "k-row",
  props: {
    gutter: {
      type: [Number, String]
    },
    align: {
      validator: function(val) {
        return ["center", "left", "right"].includes(val);
      }
    }
  },
  computed: {
    rowStyle() {
      let { gutter } = this;
      return `margin-left:-${gutter / 2}px;margin-right:-${gutter / 2}px;`;
    },
    rowClass() {
      let { align } = this;
      return align && `align-${align}`;
    }
  },
  mounted() {
    this.$children.forEach(vm => {
      vm.gutter = this.gutter;
    });
  }
};
</script>

<style lang="less">
.k-row {
  display: flex;
  height: auto;
  margin: 20px 0;
  align-items: top;
  display: flex;
  flex-wrap: wrap;
  &.align-left {
    justify-content: flex-start;
  }
  &.align-right {
    justify-content: flex-end;
  }
  &.align-center {
    justify-content: center;
  }
}
</style>
